<template>
  <ModelManagerPage
          lower-app-name="emarket"
          lower-model-name="categoryl2"
          version="1"
          obj-label="商品二级分类"
          parent-field-name="category_l1_id"
          v-bind:parent-id="parentId">
  </ModelManagerPage>
</template>

<script>
import ModelManagerPage from './ModelManagerPage.vue'

export default {
  name: 'CategoryL2Manager',
  props: {
  },
  computed: {
    parentId: function () {
      return parseInt(this.$route.params.parentId)
    }
  },
  components: {
    ModelManagerPage
  },
  data: function () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// CategoryL2Manager.vue?6baa1176